import { clsx } from 'clsx';

import { splitForMiddleTruncation } from './middleTruncateText';

import styles from './MiddleTruncate.module.css';

export interface MiddleTruncateProps {
  text: string;
  title?: string;
  className?: string;
  maxTailChars?: number;
}

export function MiddleTruncate({ text, title, className, maxTailChars }: MiddleTruncateProps) {
  const { head, tail } = splitForMiddleTruncation(text, { maxTailChars });
  return (
    <span className={clsx(styles.root, className)} title={title ?? text}>
      <span className={styles.head}>{head}</span>
      {tail && <span className={styles.tail}>{tail}</span>}
    </span>
  );
}
